import React from 'react';
import RadioButton from '@material-ui/core/Radio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarSide, faMotorcycle } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useCollection } from '../../utility/hooks/useCollection';
import { editCollectionRegister } from '../../redux/actions/form';

export const RadioList = (props) => {
  const { name } = props;
  const { form } = useSelector((state) => state);
  const dispatch = useDispatch();
  const nodeForm = useCollection().getCollectionNode(form, ['vehicle']);

  const handleChange = (code) => {
    dispatch(
      editCollectionRegister([], {
        name: 'vehicle',
        value: { vehicleType: code },
      }),
    );
  };

  return (
    <div className="row">
      <div className="col-6 d-flex justify-content-center">
        <div
          className="border mx-1 w-60 d-flex justify-content-center cursor-pointer"
          style={{
            backgroundColor: nodeForm[name] === 'Car' && '#ef641733',
            borderRadius: '5px',
          }}
          onClick={() => handleChange('Car')}
        >
          <RadioButton
            type="radio"
            color={'secondary'}
            size="medium"
            name={name}
            checkedIcon={
              <FontAwesomeIcon color="#EF6417" icon={faCarSide} size={'2x'} />
            }
            icon={<FontAwesomeIcon icon={faCarSide} size={'2x'} />}
            checked={nodeForm[name] === 'Car'}
            onChange={() => handleChange('Car')}
          />
        </div>
      </div>
      <div className="col-6 d-flex justify-content-center">
        <div
          className="border mx-1 w-60 d-flex justify-content-center cursor-pointer"
          style={{
            backgroundColor: nodeForm[name] === 'Moto' && '#ef641733',
            borderRadius: '5px',
          }}
          onClick={() => handleChange('Moto')}
        >
          <RadioButton
            type="radio"
            color={'secondary'}
            size="medium"
            name={name}
            checkedIcon={
              <FontAwesomeIcon
                color="#EF6417"
                icon={faMotorcycle}
                size={'2x'}
              />
            }
            icon={<FontAwesomeIcon icon={faMotorcycle} size={'2x'} />}
            checked={nodeForm[name] === 'Moto'}
            onChange={() => handleChange('Moto')}
          />
        </div>
      </div>
    </div>
  );
};
